
import { Vue } from "vue-class-component";

export default class LoginPage extends Vue
{

}
